import { createAction, props } from '@ngrx/store';
import { ICart } from '../../shoppingCart/model/cart.model';

export const navigationSuccess = createAction('[Checkout] Navigation Success');
export const navigationFailure = createAction('[Checkout] Navigation Failure', props<{ error: string }>());
export const enrollSuccess = createAction('[Checkout] Enroll Success', (courseId: string) => ({ courseId }));

export const paymentRegister = createAction('[Checkout] Payment Register', (orderId: string, sessionId: string) => ({orderId, sessionId}));
export const paymentRegisterSuccess = createAction('[Checkout] Payment Register Success', (cart: ICart) => ({cart}));
export const paymentRegisterFailure = createAction('[Checkout] Payment Register Failure', props<{ error: string }>());

export const checkoutActions = {
    navigationSuccess,
    navigationFailure,
    enrollSuccess,
    paymentRegister,
    paymentRegisterSuccess,
    paymentRegisterFailure
}
